export enum PSkeletonType {
  CUSTOM = 'custom',
  CIRCLE = 'circle',
  INPUT_FIELD = 'input-field',
}
